// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Loader {
  min-height: 200px;
  position: relative;
}
.LoaderComponent {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 999;
  width: 100%;
}
.LoaderStatus {
  width: 40px;
  height: 40px;
  position: absolute;
  left: 50%;
  top: 50%;
  margin: -20px 0 0 -20px;
}

.Spinner {
  margin: 0 auto;
  width: 40px;
  height: 40px;
  position: relative;
  animation: spinner-chase 2.5s infinite linear both;
}
.SpinnerDot {
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
  animation: SpinnerDot 2s infinite ease-in-out both;
}
.SpinnerDot:before {
  content: "";
  display: block;
  width: 25%;
  height: 25%;
  background-color: #ccc;
  border-radius: 100%;
  animation: SpinnerDotBefore 2s infinite ease-in-out both;
}
.SpinnerDot:nth-child(1) {
  animation-delay: -1.1s;
}
.SpinnerDot:nth-child(1):before {
  animation-delay: -1.1s;
}
.SpinnerDot:nth-child(2) {
  animation-delay: -1s;
}
.SpinnerDot:nth-child(2):before {
  animation-delay: -1s;
}
.SpinnerDot:nth-child(3) {
  animation-delay: -0.9s;
}
.SpinnerDot:nth-child(3):before {
  animation-delay: -0.9s;
}
.SpinnerDot:nth-child(4) {
  animation-delay: -0.8s;
}
.SpinnerDot:nth-child(4):before {
  animation-delay: -0.8s;
}
.SpinnerDot:nth-child(5) {
  animation-delay: -0.7s;
}
.SpinnerDot:nth-child(5):before {
  animation-delay: -0.7s;
}
.SpinnerDot:nth-child(6) {
  animation-delay: -0.6s;
}
.SpinnerDot:nth-child(6):before {
  animation-delay: -0.6s;
}

@keyframes SpinnerDot {
  80%, 100% {
    transform: rotate(360deg);
  }
}
@keyframes SpinnerDotBefore {
  50% {
    transform: scale(0.4);
  }
  100%, 0% {
    transform: scale(1);
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Loader/loader.scss"],"names":[],"mappings":"AAEA;EACI,iBAAA;EACA,kBAAA;AADJ;AAGI;EACI,kBAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,YAAA;EACA,WAAA;AADR;AAII;EACI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,SAAA;EACA,QAAA;EACA,uBAAA;AAFR;;AAMA;EACI,cAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,kDAAA;AAHJ;AAKI;EACI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,OAAA;EACA,MAAA;EACA,kDAAA;AAHR;AAIQ;EACI,WAAA;EACA,cAAA;EACA,UAAA;EACA,WAAA;EACA,sBAAA;EACA,mBAAA;EACA,wDAAA;AAFZ;AAKQ;EACI,sBAAA;AAHZ;AAIY;EACI,sBAAA;AAFhB;AAKQ;EACI,oBAAA;AAHZ;AAIY;EACI,oBAAA;AAFhB;AAKQ;EACI,sBAAA;AAHZ;AAIY;EACI,sBAAA;AAFhB;AAKQ;EACI,sBAAA;AAHZ;AAIY;EACI,sBAAA;AAFhB;AAKQ;EACI,sBAAA;AAHZ;AAIY;EACI,sBAAA;AAFhB;AAKQ;EACI,sBAAA;AAHZ;AAIY;EACI,sBAAA;AAFhB;;AAQA;EACI;IAEI,yBAAA;EANN;AACF;AASA;EACI;IACI,qBAAA;EAPN;EASE;IAEI,mBAAA;EARN;AACF","sourcesContent":["@import '../../sass/common/variables';\r\n\r\n.Loader {\r\n    min-height: 200px;\r\n    position: relative;\r\n\r\n    &Component {\r\n        position: absolute;\r\n        top: 0;\r\n        left: 0;\r\n        right: 0;\r\n        bottom: 0;\r\n        z-index: 999;\r\n        width: 100%;\r\n    }\r\n\r\n    &Status {\r\n        width: 40px;\r\n        height: 40px;\r\n        position: absolute;\r\n        left: 50%;\r\n        top: 50%;\r\n        margin: -20px 0 0 -20px;\r\n    }\r\n}\r\n\r\n.Spinner {\r\n    margin: 0 auto;\r\n    width: 40px;\r\n    height: 40px;\r\n    position: relative;\r\n    animation: spinner-chase 2.5s infinite linear both;\r\n\r\n    &Dot {\r\n        width: 100%;\r\n        height: 100%;\r\n        position: absolute;\r\n        left: 0;\r\n        top: 0;\r\n        animation: SpinnerDot 2s infinite ease-in-out both;\r\n        &:before {\r\n            content: '';\r\n            display: block;\r\n            width: 25%;\r\n            height: 25%;\r\n            background-color: #ccc;\r\n            border-radius: 100%;\r\n            animation: SpinnerDotBefore 2s infinite ease-in-out both;\r\n        }\r\n\r\n        &:nth-child(1) {\r\n            animation-delay: -1.1s;\r\n            &:before {\r\n                animation-delay: -1.1s;\r\n            }\r\n        }\r\n        &:nth-child(2) {\r\n            animation-delay: -1s;\r\n            &:before {\r\n                animation-delay: -1s;\r\n            }\r\n        }\r\n        &:nth-child(3) {\r\n            animation-delay: -0.9s;\r\n            &:before {\r\n                animation-delay: -0.9s;\r\n            }\r\n        }\r\n        &:nth-child(4) {\r\n            animation-delay: -0.8s;\r\n            &:before {\r\n                animation-delay: -0.8s;\r\n            }\r\n        }\r\n        &:nth-child(5) {\r\n            animation-delay: -0.7s;\r\n            &:before {\r\n                animation-delay: -0.7s;\r\n            }\r\n        }\r\n        &:nth-child(6) {\r\n            animation-delay: -0.6s;\r\n            &:before {\r\n                animation-delay: -0.6s;\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n@keyframes SpinnerDot {\r\n    80%,\r\n    100% {\r\n        transform: rotate(360deg);\r\n    }\r\n}\r\n\r\n@keyframes SpinnerDotBefore {\r\n    50% {\r\n        transform: scale(0.4);\r\n    }\r\n    100%,\r\n    0% {\r\n        transform: scale(1);\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
